import axios, { type AxiosInstance } from 'axios';
import { Schema } from './index';

const PUBLIC_LOCATIONS_DOMAIN = import.meta.env.VITE_PUBLIC_LOCATIONS_DOMAIN;

export const client: AxiosInstance = axios.create({
  baseURL: PUBLIC_LOCATIONS_DOMAIN,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
});

export async function all(): Promise<Schema.Type[]> {
  try {
    console.log('Fetching locations from:', `${PUBLIC_LOCATIONS_DOMAIN}/all`);
    const response = await client.get('/all');
    console.log('Locations API response:', response.data);
    console.log('API response structure:', {
      hasData: !!response.data,
      hasLocations: !!response.data?.locations,
      isLocationsArray: Array.isArray(response.data?.locations),
      locationsLength: response.data?.locations?.length,
      firstLocation: response.data?.locations?.[0]
    });

    if (!response.data || !Array.isArray(response.data.locations)) {
      console.warn('Unexpected API response structure:', response.data);
      return [];
    }

    // Validate each location against the schema
    const validatedLocations = response.data.locations.map((location, index) => {
      try {
        const result = Schema.Base.safeParse(location);
        if (!result.success) {
          console.warn(`Location at index ${index} failed validation:`, result.error);
          return null;
        }
        return result.data;
      } catch (error) {
        console.error(`Error validating location at index ${index}:`, error);
        return null;
      }
    }).filter(Boolean);

    console.log('Validated locations:', validatedLocations);
    return validatedLocations;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error(
        'Axios error:',
        error.response?.status,
        JSON.stringify(error.response?.data, null, 2)
      );
      throw new Error('Failed to fetch locations');
    } else {
      console.error('Unexpected error:', error);
      throw new Error('Failed to fetch locations');
    }
  }
}
